export default __webpack_public_path__ + "static/media/5.84f2e84f.svg";